export default __webpack_public_path__ + "static/media/mitigation-water-damage-partition-wall.0c137646.jpg";